export { HotelRegistrationWizard } from './components/HotelRegistrationWizard';
export { StepValidationSummary } from './components/StepValidationSummary';
export { OnboardingChecklist } from './components/OnboardingChecklist';

// Services
export { OnboardingService } from './services/onboarding.service';
export type {
  OnboardingProgress,
  OnboardingProgressResponse,
  SaveStepDto,
  SaveStepResponse,
  CompleteOnboardingResponse,
} from './services/onboarding.service';

// Hooks
export {
  onboardingKeys,
  useOnboardingProgress,
  useSaveOnboardingStep,
  useCompleteOnboarding,
} from './hooks/useOnboarding';
